<template>
  <v-container class="px-0">
    <v-row>
      <v-col :class="{ 'px-0': mdAndUp }">
        <h1>{{ activeTranslation?.title }}</h1>

        <div v-html="sanitizeHtml(activeTranslation?.text_content)" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import type { LocaleObject } from '@nuxtjs/i18n'
import { useDisplay } from 'vuetify'
import { DirectusModule, pageFieldsFilter } from '~/types/enums'
import type { PrivacyPolicy, PrivacyPolicyTranslation } from '~/types/types'
import { sanitizeHtml } from '~/util/sanitizer'

const { mdAndUp } = useDisplay()

const { locale, locales } = useI18n()

const currentLocaleIso = computed(() => {
  return locales.value?.find((l: LocaleObject) => l.code === locale.value)?.language as string
})
useHead({
  link: [
    {
      rel: 'canonical',
      href: 'https://containerdienst.de/datenschutzerklaerung',
    },
  ],
  meta: [
    {
      name: 'robots',
      content: 'noindex, nofollow, noarchive',
    },
  ],
})

const { $directus, $readItems } = useNuxtApp()
const { data } = await useAsyncData(DirectusModule.PrivacyPolicyPage, () => {
  return $directus.request(
    $readItems(DirectusModule.PrivacyPolicyPage as any, {
      fields: pageFieldsFilter,
    }),
  )
})

const privacyPolicyPage = data.value as unknown as PrivacyPolicy
if (!privacyPolicyPage)
  throw createError({
    status: 404,
    statusText: 'Page Not Found',
  })

const activeTranslation = computed(() => {
  return privacyPolicyPage.translations?.find(
    (t: PrivacyPolicyTranslation) => t.languages_code === currentLocaleIso.value,
  )
})
useSeoMeta({
  title: privacyPolicyPage.meta_title || '',
  description: privacyPolicyPage.meta_description || '',
})
</script>

<style lang="scss" scoped>
:deep(h1) {
  hyphens: auto;
}

:deep(p) {
  padding: 10px 0;
  hyphens: auto;
}
:deep(h2) {
  margin: 16px 0;
}
:deep(h3) {
  margin: 12px 0;
}
:deep(ol) {
  margin-left: 35px;
}
</style>
